import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const HeaderText = styled.div`
  font-size: 20px;
  color: ${({ color }) => color || "rgba(0,0,0,.5)"};
  font-weight: ${({ weight }) => weight || "600"};
`;

const HeaderDetails = ({ title, color, onClick, weight }) => {
  return (
    <div>
      <HeaderText color={color} onClick={onClick} weight={weight}>
        {title}
      </HeaderText>
    </div>
  );
};

HeaderDetails.defaultProps = {
  color: null,
  weight: null,
  onClick: () => {}
};

HeaderDetails.propTypes = {
  title: PropTypes.string.isRequired,
  color: PropTypes.string,
  onClick: PropTypes.func,
  weight: PropTypes.string
};

export default HeaderDetails;
